import { AttentionStates } from '../enums/attentionsStates';
import { PROVIDER_STATUS } from '../enums/providerStatus';
import { TypeMapMarker } from '../enums/typeMapMarker';
import { themeStatusVar } from './theme.status.defaults';
import { AuthorizationState } from '../enums/authorizationState';

/** Colores de texto por estado de atención (CSS vars — tenant-aware). */
export const ATTENTIONS_COLORS: Record<string, string> = {
    [AttentionStates.AGENDADA]: themeStatusVar('statusScheduled'),
    [AttentionStates.REALIZADA]: themeStatusVar('statusDone'),
    [AttentionStates.EN_CURSO]: themeStatusVar('statusInProgress'),
    [AttentionStates.NO_REALIZADA]: themeStatusVar('statusNotDone'),
    [AttentionStates.INFORMADA]: themeStatusVar('statusInformed'),
    [AttentionStates.FACTURABLE]: themeStatusVar('statusBillable'),
    [AttentionStates.EN_PROCESO]: themeStatusVar('statusInProcess'),
    [AttentionStates.NO_INFORMADA]: themeStatusVar('statusNotDone'),
    [AttentionStates.DEBITADA]: themeStatusVar('statusNotDone'),
};

/** Colores de fondo por estado de atención (CSS vars — tenant-aware). */
export const ATTENTIONS_BACKGROUND_COLORS: Record<string, string> = {
    [AttentionStates.AGENDADA]: themeStatusVar('statusScheduledBg'),
    [AttentionStates.REALIZADA]: themeStatusVar('statusDoneBg'),
    [AttentionStates.EN_CURSO]: themeStatusVar('statusInProgressBg'),
    [AttentionStates.NO_REALIZADA]: themeStatusVar('statusNotDoneBg'),
    [AttentionStates.INFORMADA]: themeStatusVar('statusInformedBg'),
    [AttentionStates.FACTURABLE]: themeStatusVar('statusBillableBg'),
    [AttentionStates.EN_PROCESO]: 'transparent',
    [AttentionStates.NO_INFORMADA]: themeStatusVar('statusNotDoneBg'),
    [AttentionStates.DEBITADA]: themeStatusVar('statusDebitedBg'),
};

export const AUTHORIZATION_COLORS: Record<AuthorizationState, string> = {
    [AuthorizationState.AUTHORIZED]: themeStatusVar('statusAuthorized'),
    [AuthorizationState.EXPIRING_SOON]: themeStatusVar('statusExpiringSoon'),
    [AuthorizationState.EXPIRED]: themeStatusVar('statusExpired'),
    [AuthorizationState.UNAUTHORIZED]: themeStatusVar('statusUnauthorized'),
};

export const AUTHORIZATION_BACKGROUND_COLORS: Record<AuthorizationState, string> = {
    [AuthorizationState.AUTHORIZED]: themeStatusVar('statusAuthorizedBg'),
    [AuthorizationState.EXPIRING_SOON]: themeStatusVar('statusExpiringSoonBg'),
    [AuthorizationState.EXPIRED]: themeStatusVar('statusExpiredBg'),
    [AuthorizationState.UNAUTHORIZED]: themeStatusVar('statusUnauthorizedBg'),
};

export const PROVIDERS_STATUS_COLORS: Record<string, string> = {
    [PROVIDER_STATUS.ACTIVE]: themeStatusVar('statusProviderActive'),
    [PROVIDER_STATUS.INACTIVE]: themeStatusVar('statusProviderInactive'),
    [PROVIDER_STATUS.POSSIBLE]: themeStatusVar('statusProviderPossible'),
    [PROVIDER_STATUS.CANCELLED]: themeStatusVar('statusProviderCancelled'),
};

export const MAP_MARKER_COLORS: Record<TypeMapMarker, string> = {
    [TypeMapMarker.PROVIDER_ACTIVE_ADDRESS]: themeStatusVar('mapMarkerProviderActive'),
    [TypeMapMarker.PROVIDER_ACTIVE_ZONE]: themeStatusVar('mapMarkerProviderActive'),
    [TypeMapMarker.PROVIDER_INACTIVE_ADDRESS]: themeStatusVar('mapMarkerProviderInactive'),
    [TypeMapMarker.PROVIDER_INACTIVE_ZONE]: themeStatusVar('mapMarkerProviderInactive'),
    [TypeMapMarker.PROVIDER_INACTIVE_POSSIBLE_ADDRESS]: themeStatusVar('mapMarkerProviderPossible'),
    [TypeMapMarker.PROVIDER_INACTIVE_POSSIBLE_ZONE]: themeStatusVar('mapMarkerProviderPossible'),
    [TypeMapMarker.PROVIDER_INACTIVE_CANCELLED_ADDRESS]: themeStatusVar('mapMarkerProviderCancelled'),
    [TypeMapMarker.PROVIDER_INACTIVE_CANCELLED_ZONE]: themeStatusVar('mapMarkerProviderCancelled'),
    [TypeMapMarker.PATIENT_ACTIVE]: themeStatusVar('mapMarkerPatientActive'),
    [TypeMapMarker.PATIENT_INACTIVE]: themeStatusVar('mapMarkerPatientInactive'),
    [TypeMapMarker.GENERAL]: themeStatusVar('mapMarkerProviderActive'),
    [TypeMapMarker.CASE]: themeStatusVar('mapMarkerProviderActive'),
    [TypeMapMarker.CLUSTER]: themeStatusVar('mapMarkerCluster'),
};

export const PROVIDERS_STATUS_BACKGROUND_COLORS: Record<string, string> = {
    [PROVIDER_STATUS.ACTIVE]: themeStatusVar('statusProviderActiveBg'),
    [PROVIDER_STATUS.INACTIVE]: themeStatusVar('statusProviderInactiveBg'),
    [PROVIDER_STATUS.POSSIBLE]: themeStatusVar('statusProviderPossibleBg'),
    [PROVIDER_STATUS.CANCELLED]: themeStatusVar('statusProviderCancelledBg'),
};

export const PROVIDERS_DOTS_STATUS_COLORS: Record<string, string> = {
    ...PROVIDERS_STATUS_BACKGROUND_COLORS,
};
